import column from '../../../../common/list-table/helpers/columns';

export default (data, userRole, onRowDelete, onRowEdit) => {
  const {
    FilteredTextColumn,
    FilteredNullableBooleanColumn,
    FilteredTextCommaColumn,
    ActionColumn,
  } = column(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Contact ID', 'id').withShow(false),
        new FilteredTextColumn('First Name', 'firstName').withWidth(200),
        new FilteredTextColumn('Last Name', 'lastName').withWidth(200),
        new FilteredTextColumn('Phone', 'phoneNumber').withWidth(200),
        new FilteredTextColumn('E-mail', 'emailAddress').withWidth(380),
        new FilteredTextCommaColumn('Data location(s)', 'dataLocations').withWidth(200),
        new FilteredNullableBooleanColumn('Notify for failure', 'notifyOnFailure').withWidth(180),
        new ActionColumn([['DELETE', 'id', onRowDelete, true], ['EDIT', 'id', onRowEdit, true]]).withShow(userRole === 'IPC_ADMIN').withWidth(100),
      ],
    },
  ];
};
